import { CheckmarkIcon, PlusIcon } from '@airship-platform/jam-web/icons';
import CircularProgress from '@mui/material/CircularProgress';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';

interface QuickAddButtonProps extends IconButtonProps {
  isLoading: boolean;
  isAlreadyAdded: boolean;
}

const QuickAddButton: React.FC<QuickAddButtonProps> = ({
  isLoading,
  isAlreadyAdded,
  disabled,
  ...props
}) => (
  <IconButton
    disabled={isAlreadyAdded || disabled || isLoading}
    color="softGold"
    {...props}
  >
    {isLoading ? (
      <CircularProgress size={24} />
    ) : isAlreadyAdded ? (
      <CheckmarkIcon />
    ) : (
      <PlusIcon />
    )}
  </IconButton>
);

export default QuickAddButton;
